<div class="about-hero-surface">
<section class="about-hero about-container" aria-labelledby="about-title">
  <div class="about-hero-copy">
    <p class="about-eyebrow">About CircledPlus / Bengaluru & beyond</p>
    <h1 id="about-title">Exceptional properties.<br><span>Thoughtful decisions.</span></h1>
    <p class="about-lead">Circled Plus is a private luxury real estate platform built for serious decision-makers.</p>
    <p class="about-description">Our approach is relationship-led, with every engagement focused on discretion, access, and long-term alignment.</p>
    <div class="about-actions">
      <a routerLink="/search" class="about-button">Explore Homes <span aria-hidden="true">↗</span></a>
      <a routerLink="/contactus" class="about-text-link">Talk to an Advisor <span aria-hidden="true">↗</span></a>
    </div>
  </div>
  <figure class="about-hero-image">
    @if (showHeroVideo()) {
      <video src="/assets/videos/next.mp4" poster="/assets/img/about_mob.png" autoplay muted [muted]="true" loop playsinline preload="metadata" aria-label="Animated architectural walkthrough of a home"></video>
    } @else {
      <img src="/assets/img/about_mob.png" alt="Architectural cutaway of a furnished two-storey home" fetchpriority="high">
    }
  </figure>
</section>
</div>

<section class="about-section about-audience" aria-labelledby="audience-title">
  <div class="about-container about-split">
    <div>
      <p class="about-eyebrow">01 / The people we work with</p>
      <h2 id="audience-title">Ambitious lives.<br>A considered approach.</h2>
      <p class="about-description">We work with CXOs, unicorn founders, family offices, HNIs, and entrepreneurs to source, evaluate, and close high-value residential, commercial, and land assets.</p>
    </div>
    <ul class="about-audience-list">
      @for (audience of audiences; track audience; let i = $index) {
        <li><span class="about-number">0{{ i + 1 }}</span><span>{{ audience }}</span><span class="about-list-arrow" aria-hidden="true">↗</span></li>
      }
    </ul>
  </div>
</section>

<section class="about-section" aria-labelledby="trust-title">
  <div class="about-container">
    <div class="about-section-heading">
      <div><p class="about-eyebrow">02 / Trusted by global professionals</p><h2 id="trust-title">Helping leaders of leading companies<br>find their Bengaluru home.</h2></div>
      <p>From founders and CXOs to technology leaders and global professionals, we help families make confident real estate decisions in Bengaluru.</p>
    </div>
    <div class="about-logos">
      @for (logo of logos; track logo; let i = $index) {
        <div class="about-logo"><img [src]="logo" [alt]="companyNames[i]" loading="lazy"></div>
      }
    </div>
  </div>
</section>

<section class="about-section about-glance" aria-labelledby="glance-title">
  <div class="about-container">
    <p class="about-eyebrow">03 / CircledPlus at a glance</p>
    <h2 id="glance-title">Relationships built.<br>Possibilities opened.</h2>
    <div class="about-stats">
      <article><span>1000+</span><h3>CXOs, founders & HNIs engaged</h3></article>
      <article><span>300+</span><h3>Luxury & private listings</h3></article>
      <article><span>50+</span><h3>Prime micro-markets in Bengaluru</h3></article>
    </div>
  </div>
</section>

<section class="about-section" aria-labelledby="expertise-title">
  <div class="about-container about-split">
    <div><p class="about-eyebrow">04 / Expertise beyond the address</p><h2 id="expertise-title">Perspective for every<br>property decision.</h2></div>
    <div class="about-expertise">
      <p>Our expertise covers <strong>luxury residences, commercial spaces, strategic land sourcing, and investment structuring,</strong> supporting clients through high-stakes decisions with clarity and confidence.</p>
      <p>Circled Plus partners with leaders from some of India’s most respected companies and institutions, building relationships that extend well beyond transactions and are anchored in trust, discretion, and thoughtful execution.</p>
      <a routerLink="/contactus" class="about-text-link">Start a conversation <span aria-hidden="true">↗</span></a>
    </div>
  </div>
</section>

<section class="about-container about-newsletter-wrap" aria-labelledby="about-newsletter-title">
  <div class="about-newsletter">
    <div><p class="about-eyebrow">Stay in the know</p><h2 id="about-newsletter-title">A clearer view.<br>In your inbox.</h2><p class="about-description">Keep up to date with new properties and exclusive listings.</p></div>
    <form (ngSubmit)="subscribe(form)" #form="ngForm" novalidate>
      <label for="about-email">Your email address</label>
      <div class="about-email-row">
        <input id="about-email" type="email" name="email_subscribe" [(ngModel)]="email_subscribe" email autocomplete="email" #emailField="ngModel" required placeholder="Enter your email" [attr.aria-invalid]="(emailField.touched || form.submitted) && emailField.invalid ? 'true' : null" aria-describedby="about-email-help">
        <button type="submit" class="about-button" [disabled]="form.invalid">Subscribe <span aria-hidden="true">↗</span></button>
      </div>
      <p id="about-email-help" class="about-form-note">We respect your privacy. No spam, ever.</p>
      @if ((emailField.touched || form.submitted) && emailField.invalid) {
        <p class="about-form-error" role="alert">{{ emailField.errors?.['required'] ? 'Email is required.' : 'Please enter a valid email address.' }}</p>
      }
      @if (subscribeSuccess) { <p class="about-form-success" role="status">Thanks for subscribing to CircledPlus.</p> }
      @if (subscribeError) { <p class="about-form-error" role="alert">Something went wrong. Please try again later.</p> }
    </form>
  </div>
</section>
